import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  KANBAN_COLUMN_STATUSES,
  type KanbanColumnStatus,
} from '@evimo/components/maintenance/work-orders/WorkOrderKanbanPageContainer/utils';

export type KanbanColumnConfig = {
  status: KanbanColumnStatus;
  title: string;
  description: string;
};

export function useWorkOrderKanbanColumns(): KanbanColumnConfig[] {
  const { t } = useTranslation('maintenance');

  return useMemo(
    () =>
      KANBAN_COLUMN_STATUSES.map((status) => ({
        status,
        title: t(`workOrders.kanban.columns.${status}`),
        description: t(`workOrders.kanban.columnHints.${status}`),
      })),
    [t],
  );
}
